import gsap, { Power2, Power3 } from 'gsap';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import IndexBar from '../layout/IndexBar';
import Default from './Default';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';

export default class Project extends Default {
  
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();

    this._itemsShow = [
      GetBy.class("__t1", this.container)[0],
      GetBy.class("__t2", this.container)[0],
      GetBy.class("__t3", this.container)[0],
      GetBy.class("__t5", this.container)[0],
      GetBy.class("__t4", this.container)[0]
    ];
  }

  afterShow() {
    super.afterShow();

    let delay = 0;
    let inc = .04;
    let time = 0;

    for(let i=0,j=this._itemsShow.length; i<j; i++) {
      const item = this._itemsShow[i];

      if(i < j-1) {
        delay = delay + inc * i;
        gsap.to(item, {opacity:1, duration:.2, delay: delay});
      
      } else {
        delay = delay + inc * i;

        let distance = Maths.maxminRandom(Metrics.WIDTH * .015, Metrics.WIDTH * .01);
        const offset = {
          x: Math.random() > .5 ? 1 : -1,
          y: Math.random() > .5 ? -1 : 1
        }

        gsap.killTweensOf(item);
        gsap.set(item, { x: offset.x * distance * 2, y: offset.y * distance, force3D: true });

        gsap.to(item, { x: 0, duration: .3, delay: delay, ease: Power3.easeOut });
        gsap.to(item, { y: 0, duration: .4, delay: delay + .1, ease: Power3.easeInOut });
        gsap.to(item, { opacity: 1, duration: .1, delay: delay, ease: Power2.easeIn });
      }
    }
  }
}

ControllerPage._addPage("project", Project)
